import React from "react";
import Button from "@material-ui/core/Button";
import mixpanel from "mixpanel-browser";
import ButtonGroup from "@material-ui/core/ButtonGroup";

import { Container, Plan, Free, Price } from "./styles";
import plans from "./plans.json";

function Plans() {
  const [selectedPrice, setSelectedPrice] = React.useState(0);

  React.useEffect(() => {
    mixpanel.track("ViewPrice");
  }, []);

  return (
    <Container className="main-section-content">
      {/*  <Plan className="gray-background">
        <div>
          <h2 style={{ color: "#373737", fontSize: "28px" }}>Iniciante</h2>
          <ul>
            <li>Receber pedidos ilimitados no WhatsApp</li>
            <li>
              Suporte em horário comercial <br />
              <small>(via chat e e-mail)</small>
            </li>
          </ul>
          <Free>Grátis</Free>
        </div>
      </Plan> */}

      <Plan>
        <div>
          <h2 className="blue-font-color">Essencial</h2>
          <ul>
            <li>Suporte via WhatsApp até as 23 horas</li>
            <li>Pedidos Ilimitados</li>
            <li>Receber pedidos via WhatsApp</li>
            <li>Taxa de Entrega Fixa ou por Bairro</li>
            <li>
              Gestor de pedidos <small>(Computador e celular)</small>
            </li>
            <li>Relatório de Pedidos</li>
            <li>Até 200 produtos</li>
          </ul>

          {/* <Price>
            <span className="top-info-price">20% Off</span>
            <span className="price">
              <small>R$</small> 383,00
            </span>
            <span className="bottom-info-price">
              no plano <strong>Anual</strong>
            </span>
          </Price> */}
          <Price>
            {/* <span className="top-info-price">Apenas</span> */}
            <span className="price">
              <small>R$</small> 69,90
            </span>
            <span className="bottom-info-price">
              no plano <strong>Mensal</strong>
            </span>
          </Price>

          <Button
            onClick={() => {
              mixpanel.track("InitiateCheckout", { plan: 1 });
              if (window.fbq) {
                window.fbq("track", "InitiateCheckout");
              }
            }}
            size="large"
            variant="contained"
            color="primary"
            type="submit"
            target="_blank"
            href="https://api.whatsapp.com/send?phone=553498807793&text=Oi%2C%20eu%20quero%20assinar%20o%20plano%20Essencial.%20Como%20eu%20fa%C3%A7o%20o%20pagamento%3F"
          >
            Assinar agora
          </Button>
        </div>
      </Plan>
    </Container>
  );
}

export default Plans;
